/* eslint-disable react/prop-types */

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { USER_OPR_STATE } from '../constants';
import * as faqsActions from '../actions/faqsActions';
import * as faqsCategoryActions from '../actions/faqsCategoryActions';
import * as faqsQuestionActions from '../actions/faqsQuestionActions';
import * as selectors from '../reducers';

import Category from '../components/Category';

const actions = {
  ...faqsActions,
  ...faqsCategoryActions,
  ...faqsQuestionActions,
};

export class FaqsContainer extends React.Component {
  componentDidMount() {
    const { callbacks } = this.props;

    callbacks.loadFaqsSuccessful(this.props.groups);
    callbacks.loadEditPerm(this.props.edit_perm);
    callbacks.loadEditGlobalPerm(this.props.edit_global_perm);
  }

  handleAddCategory = () => {
    const { callbacks } = this.props;
    callbacks.addCategory();
  };

  render() {
    const { data, generalOprs, categoryOprs, questionOprs, callbacks } =
      this.props;

    const categoryNodes = data.map((ctg, idx) => (
      <div key={idx}>
        <Category
          category={ctg}
          generalOprs={selectors.getEditPermissions(generalOprs)}
          categoryOprs={selectors.getCategoryOprs(categoryOprs, ctg)}
          questionOprs={selectors.getQuestionOprsGroup(
            questionOprs,
            ctg.questions,
          )}
          callbacks={callbacks}
        />
        <hr />
      </div>
    ));

    const addButtonNode = selectors.getEditPermissions(generalOprs)[
      USER_OPR_STATE.EDIT_PERM
    ] ? (
      <div className="btn-group">
        <button
          type="button"
          className="btn btn-xs btn-primary"
          onClick={this.handleAddCategory}
        >
          Add category
        </button>
      </div>
    ) : null;

    return (
      <div>
        <h1>Frequently Asked Questions</h1>
        {categoryNodes}
        {addButtonNode}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: selectors.data(state.faqs),
    generalOprs: selectors.generalOprs(state.faqs),
    categoryOprs: selectors.categoryOprs(state.faqs),
    questionOprs: selectors.questionOprs(state.faqs),
  };
}

function mapDispatchToProps(dispatch) {
  return { callbacks: bindActionCreators(actions, dispatch) };
}

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default connect(mapStateToProps, mapDispatchToProps)(FaqsContainer);
